<div class="row">
  <div class="col-lg-6" *ngFor="let section of sections">
    <div class="vk-card">
      <div class="vk-head">
        <span class="vk-icon" [ngClass]="section.platform == 'ANDROID' ? 'android' : 'ios'">
          <!-- inline brand marks: the theme's Font Awesome has no brand icons -->
          <svg *ngIf="section.platform == 'ANDROID'" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M17.6 9.48l1.84-3.18a.38.38 0 00-.66-.38l-1.86 3.23a11.43 11.43 0 00-9.84 0L5.22 5.92a.38.38 0 00-.66.38L6.4 9.48A10.78 10.78 0 001 18h22a10.78 10.78 0 00-5.4-8.52zM7 15.25A1.25 1.25 0 118.25 14 1.25 1.25 0 017 15.25zm10 0A1.25 1.25 0 1118.25 14 1.25 1.25 0 0117 15.25z"/>
          </svg>
          <svg *ngIf="section.platform != 'ANDROID'" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M16.36 12.76c-.02-2.22 1.81-3.28 1.89-3.33-1.03-1.5-2.63-1.71-3.2-1.73-1.36-.14-2.66.8-3.35.8-.69 0-1.76-.78-2.89-.76-1.49.02-2.86.86-3.62 2.19-1.55 2.68-.4 6.64 1.11 8.81.74 1.06 1.61 2.26 2.76 2.22 1.11-.05 1.53-.72 2.87-.72 1.34 0 1.72.72 2.89.7 1.2-.02 1.95-1.08 2.68-2.15.85-1.23 1.19-2.42 1.21-2.48-.03-.01-2.32-.89-2.35-3.55zM14.16 5.83c.61-.74 1.02-1.77.91-2.8-.88.04-1.94.59-2.57 1.32-.56.65-1.06 1.7-.93 2.7.98.08 1.98-.5 2.59-1.22z"/>
          </svg>
        </span>
        <div>
          <h6 class="vk-title">{{section.platform == 'ANDROID' ? 'Android' : 'iOS'}}</h6>
          <div class="vk-subtitle">Versi minimum, force update, dan mode maintenance aplikasi mobile.</div>
        </div>
      </div>

      <div class="vk-loading" *ngIf="section.isLoading">
        <img src="assets/images/preloaders/3.svg" class="vk-loading-img" alt="Memuat data">
      </div>

      <form *ngIf="!section.isLoading" [formGroup]="section.form" (ngSubmit)="onSubmit(section)">
        <div class="vk-body">
          <div class="vf-field">
            <label class="vf-label">Version Code <span class="req">*</span></label>
            <input type="text" inputmode="numeric" class="vf-input" [class.invalid]="isInvalid(section,'version_code')"
                   placeholder="Misal: 42" formControlName="version_code">
            <div class="vf-error" *ngIf="isInvalid(section,'version_code')">Version code wajib diisi.</div>
          </div>
          <div class="vf-field">
            <label class="vf-label">Version Name <span class="req">*</span></label>
            <input type="text" class="vf-input" [class.invalid]="isInvalid(section,'version_name')"
                   placeholder="Misal: 1.4.2" formControlName="version_name">
            <div class="vf-error" *ngIf="isInvalid(section,'version_name')">Version name wajib diisi.</div>
          </div>
          <div class="vf-field">
            <label class="vf-label">Force Update <span class="req">*</span></label>
            <select class="vf-input vf-select" [class.invalid]="isInvalid(section,'is_force_update')" formControlName="is_force_update">
              <option [ngValue]="''" disabled hidden>Pilih</option>
              <option *ngFor="let d of isForce" [ngValue]="d.id">{{d.text}}</option>
            </select>
            <div class="vf-hint">Kalau "Ya", pengguna di bawah Version Code ini wajib update sebelum bisa lanjut pakai aplikasi.</div>
            <div class="vf-error" *ngIf="isInvalid(section,'is_force_update')">Wajib dipilih.</div>
          </div>
          <div class="vf-field">
            <label class="vf-label">Maintenance Mode <span class="req">*</span></label>
            <select class="vf-input vf-select" [class.invalid]="isInvalid(section,'is_maintenance')" formControlName="is_maintenance">
              <option [ngValue]="''" disabled hidden>Pilih</option>
              <option *ngFor="let d of isMaintenance" [ngValue]="d.id">{{d.text}}</option>
            </select>
            <div class="vf-hint">Kalau "Ya", semua pengguna {{section.platform == 'ANDROID' ? 'Android' : 'iOS'}} akan melihat halaman maintenance.</div>
            <div class="vf-error" *ngIf="isInvalid(section,'is_maintenance')">Wajib dipilih.</div>
          </div>
        </div>
        <!-- Fitur: saved on toggle, independent of the version form below -->
        <div class="vk-features" *ngIf="settings">
          <div class="vk-feature">
            <div class="vk-feature-text">
              <span class="vf-label">Tampilkan Voucher</span>
              <span class="vf-hint">Tombol tukar voucher di aplikasi {{section.platform == 'ANDROID' ? 'Android' : 'iOS'}}.
                Biarkan mati saat review {{section.platform == 'ANDROID' ? 'Google Play' : 'App Store'}}: toko hanya mengizinkan pembelian lewat billing mereka.</span>
            </div>
            <button type="button" class="vk-switch" role="switch"
                    [attr.aria-checked]="settings[voucherKey(section.platform)]"
                    [class.on]="settings[voucherKey(section.platform)]"
                    [disabled]="settingSaving == voucherKey(section.platform)"
                    (click)="toggleSetting(voucherKey(section.platform), 'Voucher ' + (section.platform == 'ANDROID' ? 'Android' : 'iOS'))">
              <span class="vk-knob"></span>
            </button>
          </div>
        </div>
        <div class="vk-foot">
          <button type="submit" class="vl-btn-primary">
            Simpan {{section.platform == 'ANDROID' ? 'Android' : 'iOS'}}</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- save confirmation dialog (custom, design-system styled — matches the rest of the app) -->
<div class="hds-overlay" *ngIf="isConfirm" (click)="closeConfirm()">
  <div class="hds-dialog" role="alertdialog" aria-modal="true" (click)="$event.stopPropagation()">
    <div class="hds-a">
      <span class="hds-ico">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
             stroke-linejoin="round"><path d="M12 9v4M12 17h.01M10.3 3.9L1.8 18a2 2 0 001.7 3h17a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0z"/></svg>
      </span>
      <h3>Simpan konfigurasi {{isConfirm.platform == 'ANDROID' ? 'Android' : 'iOS'}}?</h3>
      <p>Perubahan berlaku langsung untuk semua pengguna {{isConfirm.platform == 'ANDROID' ? 'Android' : 'iOS'}}.</p>
    </div>
    <div class="hds-foot hds-foot-full">
      <button type="button" class="vl-btn-ghost" [disabled]="isSaving" (click)="closeConfirm()">Batal</button>
      <button type="button" class="vl-btn-primary" [disabled]="isSaving" (click)="confirmSave()">
        <i class="fa fa-spinner fa-spin" *ngIf="isSaving"></i> Ya, Simpan</button>
    </div>
  </div>
</div>
